import { PageId } from 'constants/pages'
import type { TPageConfig } from 'models/common.model'
import { PageIdIntl1T } from './pages'
import { HeaderId } from 'root-constants'

export const ID_TO_PAGE_CONFIG_MAP_INTL_1T: Record<PageIdIntl1T, TPageConfig> =
  {
    [PageId.START_INTL_1T]: {
      id: PageId.START_INTL_1T,
      hasHeader: true,
      headerId: HeaderId.LOGO_MENU,
      legalNotice: 'inline',
    },
    [PageId.QUESTION_1_INTL_1T]: {
      id: PageId.QUESTION_1_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_2_INTL_1T]: {
      id: PageId.QUESTION_2_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_3_INTL_1T]: {
      id: PageId.QUESTION_3_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_4_INTL_1T]: {
      id: PageId.QUESTION_4_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.SPEED_FEEDBACK_INTL_1T]: {
      id: PageId.SPEED_FEEDBACK_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.QUESTION_5_INTL_1T]: {
      id: PageId.QUESTION_5_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_6_INTL_1T]: {
      id: PageId.QUESTION_6_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_7_INTL_1T]: {
      id: PageId.QUESTION_7_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_8_INTL_1T]: {
      id: PageId.QUESTION_8_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_9_INTL_1T]: {
      id: PageId.QUESTION_9_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_10_INTL_1T]: {
      id: PageId.QUESTION_10_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_11_INTL_1T]: {
      id: PageId.QUESTION_11_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_12_INTL_1T]: {
      id: PageId.QUESTION_12_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.SMARTNESS_FEEDBACK_INTL_1T]: {
      id: PageId.SMARTNESS_FEEDBACK_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.QUESTION_13_INTL_1T]: {
      id: PageId.QUESTION_13_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_14_INTL_1T]: {
      id: PageId.QUESTION_14_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_15_INTL_1T]: {
      id: PageId.QUESTION_15_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_16_INTL_1T]: {
      id: PageId.QUESTION_16_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_17_INTL_1T]: {
      id: PageId.QUESTION_17_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_18_INTL_1T]: {
      id: PageId.QUESTION_18_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_19_INTL_1T]: {
      id: PageId.QUESTION_19_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_20_INTL_1T]: {
      id: PageId.QUESTION_20_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.LOGICAL_SKILLS_FEEDBACK_INTL_1T]: {
      id: PageId.LOGICAL_SKILLS_FEEDBACK_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.QUESTION_21_INTL_1T]: {
      id: PageId.QUESTION_21_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_22_INTL_1T]: {
      id: PageId.QUESTION_22_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_23_INTL_1T]: {
      id: PageId.QUESTION_23_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_24_INTL_1T]: {
      id: PageId.QUESTION_24_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.QUESTION_25_INTL_1T]: {
      id: PageId.QUESTION_25_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      progressBar: 'controlled',
      headerId: HeaderId.BACK_LOGO_MENU_TIMER,
    },
    [PageId.AGE_QUESTION_INTL_1T]: {
      id: PageId.AGE_QUESTION_INTL_1T,
      hasHeader: true,
      headerId: HeaderId.LOGO_MENU,
    },
    [PageId.EDUCATION_QUESTION_INTL_1T]: {
      id: PageId.EDUCATION_QUESTION_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      headerId: HeaderId.LOGO_MENU,
    },
    [PageId.DISCOVER_FEEDBACKS_INTL_1T]: {
      id: PageId.DISCOVER_FEEDBACKS_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      headerId: HeaderId.LOGO_MENU,
    },
    [PageId.PREPARE_FLOW_INTL_1T]: {
      id: PageId.PREPARE_FLOW_INTL_1T,
      hasHeader: true,
      headerId: HeaderId.LOGO_ONLY,
    },
    [PageId.EMAIL_INTL_1T]: {
      id: PageId.EMAIL_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.OFFER_INTL_1T]: {
      id: PageId.OFFER_INTL_1T,
    },
    [PageId.PAYMENT_INTL_1T]: {
      id: PageId.PAYMENT_INTL_1T,
    },
    [PageId.REGISTRATION_INTL_1T]: {
      id: PageId.REGISTRATION_INTL_1T,
      hasHeader: true,
      headerId: HeaderId.POLICY,
    },
    [PageId.NAME_ENTRY_INTL_1T]: {
      id: PageId.NAME_ENTRY_INTL_1T,
      hasHeader: true,
      headerId: HeaderId.POLICY,
    },
    [PageId.CERTIFICATE_INTL_1T]: {
      id: PageId.CERTIFICATE_INTL_1T,
      hasHeader: true,
      hasHeaderBackButton: true,
      headerId: HeaderId.BACK_LOGO_MENU,
    },
    [PageId.REPORT_INTL_1T]: {
      id: PageId.REPORT_INTL_1T,
      hasHeader: true,
      headerId: HeaderId.LOGO_MENU,
    },
  }
